import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  position: relative;
  width: 800px;
  height: 500px;
  border-radius: 25px;
  background-color: white;
  gap: 1rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    width: 75%;
  }

  @media (max-width: 768px) {
    width: 90%;
    height: 500px;
    padding: 1rem;
  }

  svg {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 1.6rem;
    height: 1.6rem;
    fill: gray;
    cursor: pointer;
  }
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  h2 {
    text-align: center;
    font-size: 1.6rem;
    font-weight: 500;
  }

  p {
    font-size: 1rem;
  }
`;

interface Props {
  forwardRef: any;
  closeModal: any;
  modalData: any;
}

const Modal: React.FC<Props> = ({ forwardRef, closeModal, modalData }) => {
  console.log(modalData?.id);
  return (
    <ModalOverlay ref={forwardRef} onClick={closeModal}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <Container>
          <h2>{modalData?.name}</h2>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "2rem",
                width: "100%",
              }}
            >
              <p style={{ fontWeight: 600 }}>Page Views:</p>
              <p>
                Gathering since -{" "}
                {new Date(modalData?.creation_date).toLocaleDateString(
                  "en-US",
                  {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  }
                )}
              </p>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "2rem",
                width: "100%",
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Clicks, Submissions, Other Data:{" "}
              </p>
              <p>
                {modalData?.id === 6
                  ? "Gathering since around March 25, 2025 *"
                  : "Gathering since around Jan 13, 2025 *"}
              </p>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              marginTop: "6rem",
            }}
          >
            <p style={{ textAlign: "left", fontSize: ".9rem" }}>
              * The precise date of clicks, submissions any any other data is
              hard to specify due to many factors during the development
              process.
            </p>
          </div>

          <div>
            <p
              onClick={closeModal}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              Close
            </p>
          </div>
        </Container>
      </ModalContent>
    </ModalOverlay>
  );
};

export default Modal;
